import { jsx } from "react/jsx-runtime";
import HistoryToggleOffIcon from "@mui/icons-material/HistoryToggleOff";
import { validateTidalLicense } from "../../base/index.js";
function HistoryToggleOff(props) {
  return /* @__PURE__ */ jsx(
    HistoryToggleOffIcon,
    {
      "data-testid": "HistoryToggleOff",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "HistoryToggleOff",
      "data-tidal-icon-meta": "map,location,time"
    }
  );
}
HistoryToggleOff.tidalIconMeta = {
  categories: "map,location,time",
  name: "HistoryToggleOff"
};
validateTidalLicense();
export {
  HistoryToggleOff
};
//# sourceMappingURL=HistoryToggleOff.js.map
